import { requestGetApi } from '../../services/api/api';
import { BASE_API_URL } from '../../constants/constants';

export const fetchHelpCenter = () => {
  return requestGetApi(`${BASE_API_URL}/courses/flat?is_help_center=1`);
};
